import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianPhoneNoFieldController extends GeneralTreatingPhysicianFieldController {}
